/**
 * Build a YouTube/Vimeo embed URL for autoplay-muted-loop reels & hero trailers.
 * For YT we also need playlist={id} for loop=1 to work cross-browser.
 */
export function buildAutoplayMutedSrc(videoSource) {
  if (!videoSource) return null;
  if (videoSource.type === "youtube") {
    const id = videoSource.video_id;
    const params = new URLSearchParams({
      autoplay: "1", mute: "1", loop: "1", playsinline: "1",
      rel: "0", modestbranding: "1", controls: "0",
      iv_load_policy: "3", disablekb: "1", cc_load_policy: "0",
      playlist: id,
    });
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
  }
  if (videoSource.type === "vimeo") {
    const id = videoSource.video_id;
    const params = new URLSearchParams({
      autoplay: "1", muted: "1", loop: "1", background: "1",
      dnt: "1", title: "0", byline: "0", portrait: "0",
      playsinline: "1", pip: "1",
    });
    return `https://player.vimeo.com/video/${id}?${params.toString()}`;
  }
  return null;
}

export function buildPosterUrl(videoSource) {
  if (videoSource?.type === "youtube" && videoSource.video_id) {
    return `https://img.youtube.com/vi/${videoSource.video_id}/hqdefault.jpg`;
  }
  return null;
}
